// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 72016 ? "fc22d32c" : chunkId) + "." + {"39386":"7caad7b208a80eb1","53348":"aada9a39c9f01f76","69197":"791a27b619088673","72016":"7418f537f4cd4b02"}[chunkId] + ".js";
};